module.exports = __webpack_public_path__ + "static/img/submit_button.e18ab63e.png";